import { StudentItemCombinedProps } from './types';

const usePresenter = (props: StudentItemCombinedProps): StudentItemCombinedProps => {
  return props;
};

export default usePresenter;
